import 'antd/dist/antd.less';
import React, { useEffect, useState, useCallback } from 'react';
import './App.less';
import { Routes, Route, useLocation } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import i18n from '../src/translations/i18n';
import SingleGift from './v2/Benefits/Rewards/SingleGift';
import { decodeToken } from './utils/settings';
import { Box, ThemeProvider } from '@mui/material';
import theme from './theme';
import ScrollToTop from './v2/ScrollTop';


// Layouts
import PublicRouteWrapper from './Layouts/PublicRouteWrapper';
import MainLayout from './Layouts/MainLayout';
import AuthWrapper from './Layouts/AuthWrapper';

// Screens
import Notifications from './screen/distributor/view/notifications/notifications';

import LoginV2 from './v2/Onboarding/View/LoginV2';
import VerifyV2 from './v2/Onboarding/View/VerifyV2';
import ForgotPasswordV2 from './v2/Onboarding/View/ForgotPasswordV2';
import RegisterV2 from './v2/Onboarding/View/RegisterV2';
import CreatePassword from './v2/Onboarding/View/CreatePassword';
import UserOnboarding from './v2/Onboarding/View/UserOnboarding';
import IndustrySelect from './v2/Onboarding/View/FirmOnboarding/industrySelect';
import SubIndustrySelect from './v2/Onboarding/View/FirmOnboarding/subIndustrySelect';
import CompanyAndRoleSelect from './v2/Onboarding/View/FirmOnboarding/companyAndRoleSelect';
import FetchFirmDetail from './v2/Onboarding/View/FirmOnboarding/fetchFirmDetail';
import FirmOnboarding from './v2/Onboarding/View/FirmOnboarding/firmOnboarding';
import FirmOnboardingSummary from './v2/Onboarding/View/FirmOnboarding/firmOnboardingSummary';

import UserDetail from './v2/MyAccount/UserDetail';
import FirmDetail from './v2/MyAccount/FirmDetail';
import { EmployeeDetails } from "./v3/MyAccount/Employee/index";
import AddNewEmployee from './v2/MyAccount/AddNewEmployee';
import ChangeCredentials from './v2/MyAccount/ChangeCredential';
import { FAQ } from './v2/MyAccount/faq';
import ContactUsAndPolicies from './v2/MyAccount/ContactUsAndPolicies';
import OnboardBuyer from './v2/OnboardBuyer/OnboardBuyer';
import KnowYouBetter from './v2/Profilers/View/KnowYouBetter';
import BusinessProfiler from './v2/Profilers/View/BusinessProfiler';
import NotFound from './v2/error/NotFound';
import MyPerformance from './v2/Performance/View/MyPerformance';
import VcpPerformanceDirectory from './v2/Performance/View/VcpPerformanceDirectory';
import VcpSalesDashBoard from './v2/Performance/View/VcpSalesDashBoard';
import PoPerformanceDetails from './v2/Performance/View/PoPerformanceDetails';
import MyRewards from './v2/Benefits/Rewards/MyRewards';
import RewardDetails from './v2/Benefits/Rewards/RewardDetails';
import RewardHistory from './v2/Benefits/Rewards/RewardHistory';
import MyNetwork from './v2/Benefits/Rewards/MyNetworkRewards';
import GapCalculator from './v2/Benefits/BenefitsRevamp/GapCalculator';
import TempTnc from './v2/Benefits/BenefitsRevamp/TempTnc';
import PWAFAQ from './v2/FAQ/PWAFaq';
import Benefits from './v2/Benefits/Beneficiary/Benefits';
import AddBeneficiary from './v2/Benefits/Beneficiary/AddBeneficiary';
import AddNominee from './v2/Benefits/Beneficiary/AddNominee';
import BeneficiaryDetail from './v2/Benefits/Beneficiary/BeneficiaryDetail';
import AddBankDetails from './v2/Benefits/Beneficiary/AddBankDetails';
import MyBenefits from './v2/Benefits/BenefitsRevamp/MyBenefits';
import LIMIDetailPage from './v2/Benefits/BenefitsRevamp/Components/LIMIDetailPage';
import GAPDetailPage from './v2/Benefits/BenefitsRevamp/Components/GAPDetailPage';
import CumulativeTDS from './v2/Benefits/BenefitsRevamp/CumulativeTDS';
import NetworkInfluencer from './v2/Benefits/Rewards/NetworkInfluencer';
import CompanyWiseInventory from './v3/Inventory/CompanyWiseInventory';
import Inventory from './v3/Inventory/Inventory';
import InventoryCart from './v3/Inventory/InventoryCart';
import InventoryCheckout from './v3/Inventory/InventoryCheckout';
import SelectSTP from './v3/Inventory/SelectSTP';
import SelectedSTP from './v3/Inventory/SelectedSTP';
import CompletedOrder from './v3/Inventory/CompletedOrder';
import ServiceUnavailable from './v2/Benefits/Beneficiary/Components/ServiceUnavailable';
import { GetMeAction } from './v2/Onboarding/auth/action';
import { initializeCleverTapAction, trackAnalyticsEvent, trackAnalyticsEventWithUserData, trackPWAModuleDetection, trackUserLogout } from './utils/clevertap/clevertapUtils';
import { loadCleverTapSDK } from './utils/clevertap/clevertapConfig';
import { setPWAAction } from './screen/auth/action';
import { resetEntityState } from './v3/Common/Entity/actions/reduxActions';
import ComponentShowcase from './v2/MUI_custom_component/ComponentShowcase';
import ShopInsurance from './v3/Beneficiary/ShopInsurance/ShopInsurance';
import ShopInsuranceDetails from './v3/Beneficiary/ShopInsurance/ShopInsuranceDetails';
import NetworkHospitalPage from './v2/Benefits/BenefitsRevamp/Components/NetworkHospitalPage';
import StaffInsurance from './v3/Beneficiary/StaffInsurance';
import ShopDetails from './v2/Benefits/BenefitsRevamp/Components/ShopDetails';
import StaffDetails from './v2/Benefits/BenefitsRevamp/Components/StaffDetails';
import MyNetworkModule from './v3/MyNetwork/MyNetwork';
import CreatePO from './v3/PO/CreatePo';
import CompletePO from './v3/PO/CompletePO';
import POList from './v3/PO/POList';
import DPDetails from './v3/DP/DPDetails/DPDetails';
import DPList from './v3/DP/DPDetails/DPList';
import CreateDp from './v3/DP/CreateDP/CreateDp';
import DPCart from './v3/DP/CreateDP/DPCart';
import STPSelection from './v3/DP/CreateDP/STPSelection';
import ShippingInfo from './v3/DP/CreateDP/ShippingInfo';
import OrderSummary from './v3/DP/CreateDP/OrderSummary';
import Checkout from './v3/DP/CreateDP/Checkout';
import CompleteDP from './v3/DP/CreateDP/CompleteDp';
import InvoiceList from './v3/Invoice/InvoiceList';
import InvoiceDetails from './v3/Invoice/InvoiceDetails';
import RegistrationLayout from './Layouts/RegistrationLayout';
import Register from './v3/Auth/Register/register';
import OTPVerification from './v3/Auth/Register/OTPVerification';
import CreateEpin from './v3/Auth/Register/CreateEpin';
import RegDetails from './v3/Auth/Register/RegDetails';
import Login from './v3/Auth/Login/Login';
import ForgetPin from './v3/Auth/Login/ForgetPin';
import SelectManufacturerRole from './v3/FirmOnboarding/SelectManufacturerRole';
import OnboardFirm from './v3/FirmOnboarding/OnboardFirm';
import ConfirmOnboardDetails from './v3/FirmOnboarding/ConfirmOnboardDetails';
import Payment from './v3/Payment/Payment';
import Home from './v3/Home';
import MyBusiness from './v3/MyBusiness';
import { Close } from './components/icons';
import AnnualTrip from "./v3/Benefits/AnnualTrip/AnnualTrip";
import TreePlantation from './v2/Benefits/TreePlantation/TreePlantation';
import Plantation from './v2/Benefits/TreePlantation/Plantation';
import RefundPolicy from './v3/CompanyPolicies/RefundPolicy';
import CancellationPolicy from './v3/CompanyPolicies/CancellationPolicy';
import TermConditions from './v3/CompanyPolicies/TermConditions';
import Privacy from './v3/CompanyPolicies/Privacy';
import ContactUs from './v3/MyAccount/ContactUs';
import Policies from './v3/MyAccount/Policies';
import Address from './v3/MyAccount/Address/Address';
import Profile from './v3/MyAccount/Profile';
import Profiler from './v3/Profiler';
import Firm from './v3/MyAccount/Firms';
import AddManufacturer from './v3/MyAccount/Firms/AddManufacturer';
import ConfirmScreen from './v3/MyAccount/Firms/ConfirmScreen';
import GSTInput from './v3/MyAccount/Firms/GSTInput';
import AddGapBeneficiary from './v3/Beneficiary/Gap/GapBeneficiary';
import AddGapNominee from './v3/Beneficiary/Gap/GapNominee';


function App() {
  const dispatch = useDispatch();
  const language = localStorage.getItem('language');
  if (language) {
    i18n.changeLanguage(language);
  }
  useEffect(() => {
    if (process.env.REACT_APP_PROD === 'true') {
      const handleContextMenu = (event) => {
        event.preventDefault();
      };

      document.addEventListener('contextmenu', handleContextMenu);

      return () => {
        document.removeEventListener('contextmenu', handleContextMenu);
      };
    }
  }, []);
  useEffect(() => {
    if (process.env.REACT_APP_PROD === 'true') {
      const handleCopy = (event) => {
        event.preventDefault();
      };

      const handleCut = (event) => {
        event.preventDefault();
      };

      const handlePaste = (event) => {
        event.preventDefault();
      };

      document.addEventListener('copy', handleCopy);
      document.addEventListener('cut', handleCut);
      document.addEventListener('paste', handlePaste);

      return () => {
        document.removeEventListener('copy', handleCopy);
        document.removeEventListener('cut', handleCut);
        document.removeEventListener('paste', handlePaste);
      };
    }
  }, []);


  const getUserLoggedInData = async() => { 
    const { data: loggedInUser } = await GetMeAction();
    dispatch({ type: 'SET_USER', data: loggedInUser });
  }
  // PWA Setup
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pwaJwt = searchParams.get('token');
  
    // Initialize CleverTap SDK on app startup
  useEffect(() => {
    const initializeCleverTap = async () => {
      try {
        await loadCleverTapSDK();
        
        // For PWA users, ensure any previous session is cleared immediately
        // This is an extra safety measure for PWA fresh starts
        if (pwaJwt || window.location.search.includes('token=')) {
          trackUserLogout('pwa_sdk_initialization');
        }
        
        // Only track PWA app launch for PWA users after SDK loads
        // Will be called again when tokenData is available
      } catch (error) {
        // Silent fail
      }
    };

    initializeCleverTap();
  }, [pwaJwt]);
  // Store token but don't track event yet - wait for CleverTap SDK to load
  if (pwaJwt) {
    localStorage.setItem('token', pwaJwt);
  }

  const [tokenData, setTokenData] = useState({});
  const [pwaDetected, setPwaDetected] = useState(false);

  useEffect(() => {
    let isMounted = true;
    
    const fetchTokenData = async () => {
      try {
        const decoded = await decodeToken();
        if (isMounted) {
          console.log('Decoded token data:', decoded);
          setTokenData(decoded);
        }
      } catch (error) {
        // Handle error silently
      }
    };
    
    fetchTokenData();
    
    return () => {
      isMounted = false;
    };
  }, []);
  useEffect(() => {
    if (tokenData && tokenData?.pwa_module && !pwaDetected) {
      getUserLoggedInData();
      setPwaDetected(true);
    }
  }, [tokenData, pwaDetected]);

  let isPwa = false;
  if (tokenData && tokenData?.pwa_module) {
    isPwa = true;
    dispatch(setPWAAction(true));
    
  } else {
    dispatch(setPWAAction(false));
  }


  const getUserDataForPWA = useCallback(async () => {
    try {
      trackUserLogout('pwa_fresh_start');
      await new Promise(resolve => setTimeout(resolve, 200));
      
      const { error: userError, data: loggedInUser } = await GetMeAction();

      if (!userError && loggedInUser) {
        const userProfileData = {
          user_id: loggedInUser.user_id || tokenData?.user_id,
          id: loggedInUser.user_id || tokenData?.user_id,
          first_name: loggedInUser.first_name,
          last_name: loggedInUser.last_name,
          email: loggedInUser.email,
          phone_no: loggedInUser.phone_no,
          is_verified: loggedInUser.is_verified || false,
          is_onboarded: loggedInUser.is_onboarded || false,
          // PWA specific data
          pwa_module: true,
          access_type: 'pwa',
        };

        await initializeCleverTapAction(userProfileData);
        
        // Track PWA module detection after user profile is initialized
        trackPWAModuleDetection(userProfileData, 'token_data');
        
        // Track PWA app launch after CleverTap is initialized
        trackAnalyticsEvent('PWA_APP_LAUNCH', {
          user_agent: navigator.userAgent,
          referrer: document.referrer || 'direct'
        });
        
        // Track PWA access via token if applicable
        if (pwaJwt) {
          trackAnalyticsEvent('PWA_ACCESS_VIA_TOKEN', {
            referrer: document.referrer || 'direct',
            token_source: 'url_parameter'
          });
        }
        
      } else if (tokenData?.user_id && tokenData?.phone_number) {
        // For cases where GetMeAction fails but we have token data (PWA users)
        const minimalUserProfile = {
          user_id: tokenData.user_id,
          id: tokenData.id,
          phone_no: tokenData.phone_number,
          pwa_module: true,
          access_type: 'pwa',
        };

        await initializeCleverTapAction(minimalUserProfile);
        
        // Track PWA module detection after user profile is initialized
        trackPWAModuleDetection(minimalUserProfile, 'token_data_minimal');
        
        // Track PWA app launch after CleverTap is initialized
        trackAnalyticsEvent('PWA_APP_LAUNCH', {
          user_agent: navigator.userAgent,
          referrer: document.referrer || 'direct'
        });
        
        // Track PWA access via token if applicable
        if (pwaJwt) {
          trackAnalyticsEvent('PWA_ACCESS_VIA_TOKEN', {
            referrer: document.referrer || 'direct',
            token_source: 'url_parameter'
          });
        }
      }
    } catch (error) {
      // Even if API fails, try to track basic PWA events with token data
      if (tokenData?.user_id) {
        // Track PWA app launch
        trackAnalyticsEvent('PWA_APP_LAUNCH', {
          user_agent: navigator.userAgent,
          referrer: document.referrer || 'direct',
          user_id: tokenData?.user_id
        });
        
        // Track PWA access via token if applicable
        if (pwaJwt) {
          trackAnalyticsEvent('PWA_ACCESS_VIA_TOKEN', {
            referrer: document.referrer || 'direct',
            token_source: 'url_parameter',
            user_id: tokenData?.user_id
          });
        }
      }
    }
  }, [tokenData, pwaJwt]);

  useEffect(() => {
    let isMounted = true;
    if (tokenData?.pwa_module && tokenData?.user_id) {
      const initializePWAUser = async () => {
        try {
          if (isMounted) {
            await getUserDataForPWA();
          }
        } catch (error) {
          // Silent fail
        }
      };
      initializePWAUser();
    }
    
    return () => {
      isMounted = false;
    };
  }, [tokenData, getUserDataForPWA]);

  useEffect(() => {
    if (!isPwa) {
      return;
    }
    const resetEntity = (reason) => {
      dispatch(resetEntityState());
    };
    const handleVisibilityChange = () => {
      if (document.hidden) resetEntity('app_backgrounded');
    };
    const handleStorageChange = (event) => {
      if (event.key === 'token' && !event.newValue && event.oldValue) {
        resetEntity('logout_detected');
      }
    };
    const handleMessage = (event) => {
      if (event.data && event.data.type === 'LOGOUT_DETECTED' && event.data.source === 'service-worker') {
        resetEntity('service_worker_logout');
      }
    };
    const checkAuthStatus = () => {
      const token = localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
      if (!token && window.location.pathname !== '/login' && window.location.pathname !== '/') {
        resetEntity('token_expired');
      }
    };
    checkAuthStatus();
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('message', handleMessage);
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', handleMessage);
    }
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('message', handleMessage);
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.removeEventListener('message', handleMessage);
      }
    };
  }, [dispatch, isPwa]);
  
  const routes = {
    basicRoutes: [
      // { path: '/resetpassword', element: <ResetPassword /> },
      // { path: '/changeNumber', element: <ChangePhoneNumber /> },
      // { path: '/editonboarding', element: <EditProfile /> },
    ],
    HomeRoute: [{ path: "/", element: <Home /> }],
    authRoutes: [
      // { path: '/privacy', element: <Privacy /> },
      // { path: '/login', element: <LoginV2 /> },
      { path: "/LoginViaOtp", element: <VerifyV2 /> },
      { path: "/VerifyUserForForgotPassword", element: <VerifyV2 /> },
      { path: "/VerifyUserForRegister", element: <VerifyV2 /> },
      { path: "/ForgotPassword", element: <ForgotPasswordV2 /> },
      { path: "/Register", element: <RegisterV2 /> },
      { path: "/CreatePassword", element: <CreatePassword /> },
      { path: "/UserOnboarding", element: <UserOnboarding /> },
      { path: "/IndustrySelect", element: <IndustrySelect /> },
      { path: "/SubIndustrySelect", element: <SubIndustrySelect /> },
      { path: "/CompanyAndRoleSelect", element: <CompanyAndRoleSelect /> },
      // { path: '/FetchFirmDetail', element: <FetchFirmDetail /> },
      // { path: '/FirmOnboarding', element: <FirmOnboarding /> },
      // { path: '/FirmOnboardingSummary', element: <FirmOnboardingSummary /> },
      { path: "*", element: <NotFound /> },
    ],
    firmOnboarding: [
      {
        path: "/firm-onboarding/select-manufacturer",
        element: <SelectManufacturerRole />,
      },
      { path: "/firm-onboarding/onboard-firm", element: <OnboardFirm /> },
      {
        path: "/firm-onboarding/confirm-details",
        element: <ConfirmOnboardDetails />,
      },
    ],
    authentication: [
      { path: "/registration", element: <Register /> },
      { path: "/otp", element: <OTPVerification /> },
      { path: "/epin", element: <CreateEpin /> },
      { path: "/user-details", element: <RegDetails /> },
      { path: "/login", element: <Login /> },
      { path: "/reset-pin", element: <ForgetPin /> },
    ],
    myBussinessRoutes: [
      {
        path: "/my-business",
        element: <MyBusiness />,
        moduleKey: "business",
        title: "My Business",
        showMenu: true,
        showProfileIcon: true,
      },
      {
        path: "/create-po",
        element: <CreatePO />,
        moduleKey: "business",
        title: "Create PO",
        showMenu: true,
        showProfileIcon: true,
      },
      {
        path: "/complete-po",
        element: <CompletePO />,
        moduleKey: "business",
        backroute: "/create-po",
        showProfileIcon: true,
        showHeader: false,
      },
      {
        path: "/po-list",
        element: <POList />,
        moduleKey: "business",
        title: "Purchase Order",
        showMenu: true,
        showProfileIcon: true,
      },
      {
        path: "/dispatch-status-list",
        element: <DPList />,
        moduleKey: "business",
        title: "Dispatch Status",
        showMenu: true,
        showProfileIcon: true,
      },
      {
        path: "/dispatch-plan-detail/:id",
        element: <DPDetails />,
        moduleKey: "business",
        title: "Order Details",
        showMenu: true,
        showProfileIcon: true,
      },
      {
        path: "/create-dp",
        element: <CreateDp />,
        moduleKey: "business",
        title: "Create DP",
        showMenu: true,
        showProfileIcon: true,
      },
      {
        path: "/dp-cart",
        element: <DPCart />,
        moduleKey: "business",
        title: "Create DP",
        showMenu: true,
        showProfileIcon: true,
      },
      {
        path: "/dp-ship-to-party-selection",
        element: <STPSelection />,
        moduleKey: "business",
        title: "Create DP",
        showMenu: true,
        showProfileIcon: true,
      },
      {
        path: "/dp-shiping-info",
        element: <ShippingInfo />,
        moduleKey: "business",
        title: "Create DP",
        showMenu: true,
        showProfileIcon: true,
      },
      {
        path: "/dp-order-summary",
        element: <OrderSummary />,
        moduleKey: "business",
        title: "Create DP",
        showMenu: true,
        showProfileIcon: true,
      },
      {
        path: "/dp-checkout",
        element: <Checkout />,
        moduleKey: "business",
        title: "Create DP",
        showMenu: true,
        showProfileIcon: true,
      },
      {
        path: "/complete-dp",
        element: <CompleteDP />,
        moduleKey: "business",
        backroute: "/dispatch-status-list",
        title: null,
        showHeader: false,
        showProfileIcon: true,
      },
      //Invoices routes
      {
        path: "/invoice-list",
        element: <InvoiceList />,
        moduleKey: "business",
        title: "Invoice",
        showMenu: true,
        showProfileIcon: true,
      },
      {
        path: "/invoice-detail/:id",
        element: <InvoiceDetails />,
        moduleKey: "business",
        title: "Invoice Details",
        showMenu: true,
        showProfileIcon: true,
      },
      {
        path: "/payment",
        element: <Payment />,
        moduleKey: "business",
        title: "Payment",
        showMenu: true,
        showProfileIcon: true,
      },
    ],
    inventoryRoutes: [
      {
        path: "/inventory",
        element: <Inventory />,
        title: "Inventory",
        backroute: isPwa ? "/pwa-main-menu" : null,
        moduleKey: "business",
        showProfileIcon: true,
      },
      {
        path: "inventory/company-inventory",
        element: <CompanyWiseInventory />,
        title: "Inventory",
        moduleKey: "business",
        // backroute: '/inventory',
        showProfileIcon: true,
      },
      {
        path: "inventory/cart",
        element: <InventoryCart />,
        title: "Inventory",
        moduleKey: "business",
        backroute: "/inventory/company-inventory",
        showProfileIcon: true,
      },
      {
        path: "inventory/select-ship-to-party",
        element: <SelectSTP />,
        title: "Inventory",
        moduleKey: "business",
        backroute: "/inventory/cart",
        showProfileIcon: true,
      },
      {
        path: "/inventory/selected-ship-to-party",
        element: <SelectedSTP />,
        title: "Inventory",
        moduleKey: "business",
        backroute: "/inventory/select-ship-to-party",
        showProfileIcon: true,
      },
      {
        path: "inventory/checkout",
        element: <InventoryCheckout />,
        title: "Inventory",
        moduleKey: "business",
        // backroute: '/inventory/select-ship-to-party',
        showProfileIcon: true,
      },
      {
        path: "inventory/order-completed",
        element: <CompletedOrder />,
        moduleKey: "business",
        showProfileIcon: true,
      },

      {
        path: "/distributor/company-wise-inventory",
        element: <CompanyWiseInventory />,
        title: "Company Wise Inventory ",
        backroute: isPwa ? "/pwa-main-menu" : null,
        showProfileIcon: true,
      },
    ],
    distributorRoutes: [
      { path: "/distributor/notifications", element: <Notifications /> },
    ],
    myPerformanceRoutes: [
      {
        path: "/my-performance/Performance",
        element: <MyPerformance />,
        title: "Performance",
        moduleKey: "analytics",
        showProfileIcon: true,
      },
      {
        path: "my-performance/network-performance",
        element: <VcpPerformanceDirectory />,
        title: "Performance",
        backroute: isPwa ? "/pwa-main-menu" : null,
        moduleKey: "analytics",
        showProfileIcon: true,
      },
      {
        path: "/my-performance/VCPSalesDashBoard",
        element: <VcpSalesDashBoard />,
        title: "Performance",
        moduleKey: "analytics",
        showProfileIcon: true,
      },
      {
        path: "/my-performance/PoPerformanceDetails",
        element: <PoPerformanceDetails />,
        title: "Performance",
        moduleKey: "analytics",
        showProfileIcon: true,
      },
    ],
    myBenefitsRoutes: [
      {
        path: "/benefits/network-rewards",
        element: <NetworkInfluencer />,
        title: "Network Rewards",
        backroute: isPwa ? "/pwa-main-menu" : null,
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/benefits/rewards-history",
        element: <RewardHistory />,
        title: "Reward History",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/benefits/rewards",
        element: <MyRewards />,
        title: "My Rewards",
        backroute: isPwa ? "/pwa-main-menu" : null,
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/benefits/reward-detail",
        element: <RewardDetails />,
        title: "Reward Details",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },

      {
        path: "/benefits/network-influencer",
        element: <MyNetwork />,
        title: "Network Rewards",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/benefits/insurance-detail",
        element: <LIMIDetailPage />,
        title: "My Benefits",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/benefits/gap-detail",
        element: <GAPDetailPage />,
        title: "My Benefits",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/benefits/stafff-insurance-detail",
        element: <StaffDetails />,
        title: "My Benefits",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/benefits/shop-insurance-detail",
        element: <ShopDetails />,
        title: "My Benefits",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },

      {
        path: "/benefits/mybenefits",
        element: <MyBenefits />,
        title: "My Benefits",
        backroute: isPwa ? "/pwa-main-menu" : null,
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/benefits/Tnc",
        element: <TempTnc />,
        title: "Terms & Conditions",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/benefits/gap-calculator",
        element: <GapCalculator />,
        title: "Gap Calculator",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },

      {
        path: "/benefits/cumulative-tds",
        element: <CumulativeTDS />,
        title: "Cumulative TDS",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/distributor/giftsdetails",
        element: <SingleGift />,
        title: "Gift Details",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/beneficiary",
        element: <Benefits />,
        title: "Beneficiary",
        backroute: isPwa ? "/pwa-main-menu" : "/",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/beneficiary/add-beneficiary",
        element: <AddBeneficiary />,
        title: "Beneficiary",
        backroute: "/beneficiary",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/beneficiary/add-nominee",
        element: <AddNominee />,
        title: "Beneficiary",
        backroute: "/beneficiary",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/beneficiary/add-bank-details",
        element: <AddBankDetails />,
        title: "Beneficiary",
        backroute: "/beneficiary",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/beneficiary/add-gap-beneficiary",
        element: <AddGapBeneficiary />,
        title: "Beneficiary",
        backroute: "/beneficiary",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/beneficiary/add-gap-nominee",
        element: <AddGapNominee />,
        title: "Beneficiary",
        backroute: "/beneficiary",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/beneficiary/detail",
        element: <BeneficiaryDetail />,
        title: "Beneficiary",
        backroute: "/beneficiary",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/serviceunavailable",
        element: <ServiceUnavailable />,
        title: "Service Unavailable",
        backroute: "/beneficiary",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/beneficiary/add-shop-details",
        element: <ShopInsurance />,
        title: "Beneficiary",
        // backroute: '/beneficiary',
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/beneficiary/shop-details",
        element: <ShopInsuranceDetails />,
        title: "Beneficiary",
        // backroute: '/beneficiary',
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/beneficiary/staff-details",
        element: <StaffInsurance />,
        title: "Beneficiary",
        // backroute: '/beneficiary',
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/benefits/network-hospital",
        element: <NetworkHospitalPage />,
        title: "My Benefits",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/annual-trip",
        element: <AnnualTrip />,
        title: "My Benefits",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
      {
        path: "/tree-plantation",
        element: <TreePlantation />,
        title: "My Benefits",
        moduleKey: "humbee-benefits",
        showProfileIcon: true,
      },
    ],
    myNetworkRoutes: [
      {
        path: "/my-network",
        element: <MyNetworkModule />,
        moduleKey: "my_network",
        title: "My Network",
        showMenu: false,
        showProfileIcon: true,
      },
      {
        path: "/onboard-buyer",
        element: <OnboardBuyer />,
        showMenu: true,
        title: "Onboard Buyer",
        moduleKey: "onboard-buyer",
        showProfileIcon: true,
      },
    ],
    myAccountsRoutes: [
      {
        path: "/my-account/contact-us",
        element: <ContactUs />,
        backroute: "/my-account",
        moduleKey: "my-account",
        title: "My Account",
        showMenu: false,
        showProfileIcon: false,
      },
      {
        path: "/my-account/policies",
        element: <Policies />,
        backroute: "/my-account",
        moduleKey: "my-account",
        title: "My Account",
        showMenu: false,
        showProfileIcon: false,
      },
      {
        path: "/my-account/address-details",
        element: <Address />,
        backroute: "/my-account",
        moduleKey: "my-account",
        title: "My Account",
        showMenu: false,
        showProfileIcon: false,
      },

      // { path: '/my-account/user-details', element: <UserDetail /> },
      {
        path: "/my-account",
        element: <Profile />,
        moduleKey: "my-account",
        title: "My Account",
        showMenu: false,
        showProfileIcon: false,
        backroute: "/",
      },

      {
        path: "/my-account/firm-details",
        element: <Firm />,
        backroute: "/my-account",
        moduleKey: "my-account",
        title: "My Account",
        showMenu: false,
        showProfileIcon: false,
      },
      {
        path: "/my-account/add-manufacturer",
        element: <AddManufacturer />,
        backroute: "/my-account",
        moduleKey: "my-account",
        title: "My Account",
        showMenu: false,
        showProfileIcon: false,
      },
      {
        path: "/my-account/confirm",
        element: <ConfirmScreen />,
        backroute: "/my-account",
        moduleKey: "my-account",
        title: "My Account",
        showMenu: false,
        showProfileIcon: false,
      },
      {
        path: "/my-account/input-screen",
        element: <GSTInput />,
        backroute: "/my-account/add-manufacturer",
        moduleKey: "my-account",
        title: "My Account",
        showMenu: false,
        showProfileIcon: false,
      },

      {
        path: "/my-account/employee-details",
        element: <EmployeeDetails />,
        backroute: "/my-account",
        moduleKey: "my-account",
        title: "My Account",
        showMenu: false,
        showProfileIcon: false,
      },

      {
        path: "/my-account/firm-details/add",
        element: <AddNewEmployee />,
        backroute: "/my-account",
        moduleKey: "my-account",
        title: "My Account",
        showMenu: false,
        showProfileIcon: false,
      },
      //  Not using in current flow
      // {
      //   path: "/my-account/change-credentials",
      //   element: <ChangeCredentials />,
      //   backroute: "/my-account",
      //   moduleKey: "my-account",
      //   title: "My Account",
      //   showMenu: false,
      //   showProfileIcon: true,
      // },
      {
        path: "/my-account/faq",
        element: <FAQ />,
        backroute: "/my-account",
        moduleKey: "my-account",
        title: "My Account",
        showMenu: false,
        showProfileIcon: false,
      },
      // Not using in current flow
      // {
      //   path: "/my-account/contact-us-and-policies",
      //   element: <ContactUsAndPolicies />,
      //   backroute: "/my-account",
      //   moduleKey: "my-account",
      //   title: "My Account",
      //   showMenu: false,
      //   showProfileIcon: true,
      // },
      {
        path: "/my-account/profiler",
        element: <Profiler />,
        backroute: "/my-account",
        moduleKey: "my-account",
        title: "My Account",
        showMenu: false,
        showProfileIcon: false,
      },
      // Not using in current flow
      // {
      //   path: "/my-account/know-you-better",
      //   element: <KnowYouBetter />,
      //   backroute: "/my-account",
      //   moduleKey: "my-account",
      //   title: "My Account",
      //   showMenu: false,
      //   showProfileIcon: true,
      // },
      // {
      //   path: "/my-account/business-profiler",
      //   element: <BusinessProfiler />,
      //   backroute: "/my-account",
      //   moduleKey: "my-account",
      //   title: "My Account",
      //   showMenu: false,
      //   showProfileIcon: true,
      // },
    ],
    PWARoute: [
      {
        path: "/pwa-main-menu",
        element: <Home />,
      },
    ],
    PWAAddons: [
      {
        path: "/pwa-faq",
        element: <PWAFAQ />,
        title: "FAQ",
        backroute: "/pwa-main-menu",
        showMenu: false,
      },
    ],
    component: [
      {
        path: "/humbee-design-system",
        element: <ComponentShowcase />,
        title: "Humbee Design System",
      },
    ],
    publicRoutes: [
      { path: "/plantation", element: <Plantation /> },
      { path: "/privacy", element: <Privacy /> },
      { path: "/refund-policy", element: <RefundPolicy /> },
      { path: "/cancellation-policy", element: <CancellationPolicy /> },
      { path: "/term-conditions", element: <TermConditions /> },
    ],
  };
  return (
    <Box
      className="App"
      sx={{
        position: "relative",
        backgroundColor: "#FAFAFA",
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          // background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 164, 37, 0.4) 100%)',
          background: `linear-gradient(178.79deg, rgba(255, 255, 255, 0) 24.32%, rgba(255, 165, 37, 1) 98.24%)`,
          opacity: 0.1,
          pointerEvents: "none",
        },
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
        // height:{ xs:'auto' , md: 'auto', lg: '100vh' },
      }}>
      <ThemeProvider theme={theme}>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick={true}
          rtl={false}
          pauseOnFocusLoss={true}
          draggable={true}
          pauseOnHover={true}
          theme="light"
          closeButton={<Close />}
          icon={false}
          style={{
            zIndex: 20000,
            width: "400px",
          }}
        />
        <ScrollToTop />
        <Routes>
          {routes.HomeRoute.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <MainLayout
                  sidebarTitle={route?.title}
                  isPwa={isPwa}
                  backroute={route?.backroute}
                  moduleKey={null}
                  isHomePage={true}
                  showProfileIcon={route?.showProfileIcon}>
                  {route.element}
                </MainLayout>
              }
            />
          ))}
          {routes.basicRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <MainLayout
                  sidebarTitle={route?.title}
                  isPwa={isPwa}
                  backroute={route?.backroute}
                  moduleKey={route?.moduleKey}
                  showMenu={route?.showMenu}
                  showProfileIcon={route?.showProfileIcon}>
                  {route.element}
                </MainLayout>
              }
            />
          ))}
          {routes.component.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <MainLayout
                  sidebarTitle={route?.title}
                  isPwa={isPwa}
                  backroute={route?.backroute}
                  moduleKey={route?.moduleKey}
                  showMenu={route?.showMenu}
                  showProfileIcon={route?.showProfileIcon}>
                  {route.element}
                </MainLayout>
              }
            />
          ))}

          {routes.myBussinessRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <MainLayout
                  sidebarTitle={route?.title}
                  isPwa={isPwa}
                  backroute={route?.backroute}
                  moduleKey={route?.moduleKey}
                  showMenu={route?.showMenu}
                  isHomePage={route?.isHomePage || false}
                  showHeader={route?.showHeader}
                  showProfileIcon={route?.showProfileIcon}>
                  {route.element}
                </MainLayout>
              }
            />
          ))}
          {routes.inventoryRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <MainLayout
                  moduleKey={route?.moduleKey}
                  sidebarTitle={route?.title}
                  backroute={route?.backroute}
                  isPwa={isPwa}
                  showProfileIcon={route?.showProfileIcon}>
                  {route.element}
                </MainLayout>
              }
            />
          ))}
          {routes.myNetworkRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <MainLayout
                  sidebarTitle={route?.title}
                  isPwa={isPwa}
                  backroute={route?.backroute}
                  moduleKey={route?.moduleKey}
                  isHomePage={false}
                  showMenu={route?.showMenu}
                  showProfileIcon={route?.showProfileIcon}>
                  {route.element}
                </MainLayout>
              }
            />
          ))}
          {routes.distributorRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <MainLayout
                  sidebarTitle={route?.title}
                  moduleKey={route?.moduleKey}
                  backroute={route?.backroute}
                  isPwa={isPwa}
                  showProfileIcon={route?.showProfileIcon}>
                  {route.element}
                </MainLayout>
              }
            />
          ))}
          {routes.myPerformanceRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <MainLayout
                  sidebarTitle={route?.title}
                  backroute={route?.backroute}
                  moduleKey={route?.moduleKey}
                  isPwa={isPwa}
                  isHomePage={false}
                  showProfileIcon={route?.showProfileIcon}>
                  {route.element}
                </MainLayout>
              }
            />
          ))}
          {routes.myBenefitsRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <MainLayout
                  sidebarTitle={route?.title}
                  backroute={route?.backroute}
                  isPwa={isPwa}
                  moduleKey={route?.moduleKey}
                  showProfileIcon={route?.showProfileIcon}>
                  {route.element}
                </MainLayout>
              }
            />
          ))}
          {routes.myAccountsRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <MainLayout
                  sidebarTitle={
                    route?.title ? route?.title : "Manage Your Account"
                  }
                  backroute={route?.backroute}
                  isPwa={isPwa}
                  moduleKey={route?.moduleKey}
                  showMenu={route?.showMenu}
                  showProfileIcon={route?.showProfileIcon}>
                  {route.element}
                </MainLayout>
              }
            />
          ))}
          {routes.authRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={<AuthWrapper>{route.element}</AuthWrapper>}
            />
          ))}
          {routes.firmOnboarding.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={<AuthWrapper>{route.element}</AuthWrapper>}
            />
          ))}
          {routes.PWARoute.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <MainLayout
                  sidebarTitle={route?.title}
                  isPwa={isPwa}
                  backroute={route?.backroute}
                  moduleKey={null}
                  isHomePage={true}
                  showMenu={route?.showMenu}>
                  {route.element}
                </MainLayout>
              }
            />
          ))}
          {routes.PWAAddons.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <MainLayout
                  sidebarTitle={route?.title}
                  isPwa={isPwa}
                  backroute={route?.backroute}
                  moduleKey={null}
                  isHomePage={false}
                  showMenu={route?.showMenu}>
                  {route.element}
                </MainLayout>
              }
            />
          ))}
          {routes.authentication.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <RegistrationLayout
                  sidebarTitle={route?.title}
                  isPwa={isPwa}
                  backroute={route?.backroute}
                  moduleKey={null}
                  isHomePage={false}>
                  {route.element}
                </RegistrationLayout>
              }
            />
          ))}
          {routes.publicRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={<PublicRouteWrapper>{route.element}</PublicRouteWrapper>}
            />
          ))}
          {routes.component.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Routes>
      </ThemeProvider>
    </Box>
  );
}

export default App;